export const getters = {
  getParams: state => state.params
}